import React, { FC } from 'react';

interface IProps {
  className?: string;
  size?: number | string;
}

const PlayIcon: FC<IProps> = ({ className, size = '100%' }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" className={className}>
    <g fill="none">
      <circle stroke="currentColor" strokeWidth={1} cx="24" cy="24" r="23.5" />
      <path
        d="M33.32,23.81 C33.80,24.09 33.80,24.55 33.32,24.84 L18.85,33.52 C18.38,33.81 18,33.59 18,33.05 L18,15.60 C18,15.05 18.38,14.84 18.85,15.12 L33.32,23.81 Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default PlayIcon;
